import React from "react";
import LeafletContainer from "./LeafletContainer.js";
import withRouter from "../../withRouter.js";
import { connect } from "react-redux";
import { loadProjects } from "../../Redux/actions/projects.js";
import { openModal, setHasVisitedHome, closeModal } from "../../Redux/actions/ui.js";
import { resetTitles, setLayerContentMode, openSidebar } from "../../Redux/actions/sidebarUI.js";
import { setActivePageType, setActiveCompanyID, setActiveProjectID } from "../../Redux/actions/activePage.js";
import { loadGeojson, setNextBounds } from "../../Redux/actions/mapData.js";
import { loadGeoJsonFromSearch } from "./utils/gjsonDeepLink.js";
import axios from "../../axios-config.js";

class MapPage extends React.Component {
  constructor(props) {
    super(props);
    this.getPublicProjects = this.getPublicProjects.bind(this);
    this.validateGeoJSON = this.validateGeoJSON.bind(this);
    this.state = {
      requestInProgress: false,
      allProjects: {},
    };
  }

  componentDidMount() {
    this.getPublicProjects();
    this.validateGeoJSON();
    this.props.resetTitles();

    // Check for view mode in query params
    const queryParams = new URLSearchParams(this.props.location.search);
    const viewMode = queryParams.get("view") === "3d" ? "3D" : "2D";

    // Set the page mode based on URL parameter
    this.props.setPageMode(viewMode);

    this.props.setActivePageType("HOME");
    this.props.setActiveCompanyID("");
    this.props.setActiveProjectID("");

    this.props.setHasVisitedHome();
    this.props.closeModal();

    if (window.innerWidth > 768) {
      setTimeout(this.props.openSidebar, 500);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.token !== prevProps.token) {
      this.getPublicProjects();
    }

    const prevParams = new URLSearchParams(prevProps.location.search);
    const currentParams = new URLSearchParams(this.props.location.search);
    const prevView = prevParams.get("view");
    const currentView = currentParams.get("view");

    if (prevView !== currentView) {
      const viewMode = currentView === "3d" ? "3D" : "2D";
      this.props.setPageMode(viewMode);
    }

    if (prevParams.get("gjson") !== currentParams.get("gjson")) {
      this.validateGeoJSON();
    }
  }

  getPublicProjects() {
    if (this.state.requestInProgress) return;

    this.setState({ requestInProgress: true });

    axios
      .get(`/project?_t=${Date.now()}`)
      .then((result) => {
        const data = result.data.data;
        const featuredProjects = {};
        const allProjects = {};

        data.forEach((project) => {
          const projectID = String(project.project_id);
          allProjects[projectID] = project;

          if (project.featured_site_map) {
            featuredProjects[projectID] = project;
          }
        });

        this.setState({ allProjects });
        this.props.loadProjects(featuredProjects);
      })
      .catch((error) => {
        console.error("Failed to load projects:", error);
      })
      .finally(() => {
        this.setState({ requestInProgress: false });
      });
  }

  validateGeoJSON() {
    try {
      loadGeoJsonFromSearch(this.props.location.search, this.props.loadGeojson, this.props.setNextBounds);
    } catch (e) {
      console.log("Error parsing GeoJSON from URL:", e);
    }
  }

  render() {
    let projects = Object.assign({}, this.props.projects);

    if (Object.keys(this.props.activeFilters).length > 0) {
      const filteredProjectIDs = new Set((this.props.filteredProjects || []).map((id) => String(id)));
      const fallbackProjects = Object.assign({}, this.state.allProjects || {}, this.props.projects || {}, this.props.filteredProjectData || {});
      const filteredProjects = {};

      filteredProjectIDs.forEach((projectID) => {
        const project = fallbackProjects[projectID];
        if (project) {
          filteredProjects[projectID] = project;
        }
      });

      projects = filteredProjects;
    }

    const mapTileLayers = this.props.mapTileLayers;
    const sidebarItems = this.props.sidebarItems;

    return (
      <LeafletContainer
        path={this.props.match.path}
        history={this.props.history}
        projects={projects}
        mapLayers={mapTileLayers}
        sidebarItems={sidebarItems}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.user.token,
  projects: state.projects,
  activeFilters: state.projectsFilters.active,
  filteredProjects: state.projectsFilters.results,
  filteredProjectData: state.projectsFilters.projectData,
  mapTileLayers: state.mapTileLayers,
  sidebarItems: state.sidebarItems,
  layerContentMode: state.sidebarUI.layerContentMode,
});

const mapDispatchToProps = (dispatch) => ({
  loadProjects: (projects) => {
    dispatch(loadProjects(projects));
  },
  resetTitles: (title) => {
    dispatch(resetTitles(title));
  },
  setPageMode: (mode) => {
    dispatch(setLayerContentMode(mode));
  },
  openModal: (modalName) => {
    dispatch(openModal(modalName));
  },
  closeModal: () => {
    dispatch(closeModal());
  },
  setHasVisitedHome: () => {
    dispatch(setHasVisitedHome());
  },
  openSidebar: () => {
    dispatch(openSidebar());
  },
  setActivePageType: (value) => {
    dispatch(setActivePageType(value));
  },
  setActiveCompanyID: (value) => {
    dispatch(setActiveCompanyID(value));
  },
  setActiveProjectID: (value) => {
    dispatch(setActiveProjectID(value));
  },
  loadGeojson: (data) => {
    dispatch(loadGeojson(data));
  },
  setNextBounds: (data) => {
    dispatch(setNextBounds(data));
  },
});

const HomeMapContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(MapPage));

export default HomeMapContainer;
